import React, { useEffect, useState } from "react";
import EmployeesSapTable from "./components/EmployeesSapTable";
import FilterSap from "./modals/FilterSap";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import LogSap from "./modals/LogSap"
import EmployeesDevice from "./EmployeesDevice"
import View from "./modals/ViewSap";
import LogFCountSap from "./modals/LogFCountSap"
import Divider from "@material-ui/core/Divider/index";
import ExportIcon from "@material-ui/icons/CloudDownload";
import { toast, ToastContainer } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
function EmployeesSap(props) {
  const [disabledExcel, setDisabledExcel] = useState(false)
  const [showView, setShowView] = useState(false);
  const [showFingerLog, setShowFingerLog] = useState(false);
  const [showLogDevice, setShowLogDevice] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const [saps, setSaps] = useState([]);
  const [chooseSapId, setChooseSapId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteSapsIds, setDeleteSapsIds] = useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    duty: "",
    employeeDeviceStatus: "",
    pin: "",
    status: "",
    structureId: "",
    surname: "",
    middleName: "",
    name: "",
  });

  function handleChange() {
    setShowFilter((key) => !key);
  }
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  const onSaps = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      duty,
      surname,
      middleName,
      name,
      pin,
      status,
      structureId,
      employeeDeviceStatus,
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/report?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}&source=SAP${duty ? `&duty=${duty}` : ""}${employeeDeviceStatus ? `&employeeDeviceStatus=${employeeDeviceStatus}` : ""}${middleName ? `&middleName=${middleName}` : ""}${name ? `&name=${name}` : ""}${pin ? `&pin=${pin}` : ""}${status ? `&status=${status}` : ""}${structureId ? `&structureId=${structureId}` : ""}${surname ? `&surname=${surname}` : ""}`,)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setSaps(content);

        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setSaps([]);
        setIsError(true);
      });
  };
  const success = (text = "") => {
    toast.success(text, {
      position: "top-right",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
  const onEmployeeLogFilterExport = () => {
    setDisabledExcel(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}employee/report/export?${filterInputs.duty ? `&duty=${filterInputs.duty}` : ""}${filterInputs.employeeDeviceStatus ? `&employeeDeviceStatus=${filterInputs.employeeDeviceStatus}` : ""}${filterInputs.middleName ? `&middleName=${filterInputs.middleName}` : ""}${filterInputs.name ? `&name=${filterInputs.name}` : ""}${filterInputs.pin ? `&pin=${filterInputs.pin}` : ""}&source=SAP${filterInputs.status ? `&status=${filterInputs.status}` : ""}${filterInputs.structureId ? `&structureId=${filterInputs.structureId}` : ""}${filterInputs.surname ? `&surname=${filterInputs.surname}` : ""}`,

        {
          responseType: "blob",

        }
      ).then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Employee-log.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        setDisabledExcel(false)
        success('Proses uğurludur.')

      });
  };


  const onSapChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}employee/${id}`,);
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onSaps(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);



  const [structureId, setStructureId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP`)
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setStructureId(structureId);
      });
  }, []);


  const [devicePlaceId, setDevicePlaceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace`)
      .then(({ data: { content } }) => {
        const models = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDevicePlaceId(models);
      });
  }, []);




  return (
    <div className="row bg-white rounded SHADOW">
      <div className="row w-100  mt-3 justify-content-end">
        <div className=" col-3  d-flex justify-content-end">
          <FormControlLabel
            control={
              <Switch
                checked={showFilter}
                onChange={handleChange}
                color="secondary"
              />
            }
            label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
            className="ml-auto mb-0"
          />
        </div>
        <div className=" col-1 d-flex justify-content-end"><button
          className="btn btn-sm btn-icon btn-bg-light btn-text-success btn-hover-success mr-2 h5 rounded-circle flex-shrink-0"
          onClick={onEmployeeLogFilterExport}
          disabled={disabledExcel}
        >
          <ExportIcon />
        </button>
        </div>
      </div>

      <Divider className="w-100" />

      <EmployeesSapTable
        saps={saps}
        isLoading={isLoading}
        isError={isError}
        setDeleteSapsIds={setDeleteSapsIds}
        deleteSapsIds={deleteSapsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowLog={setShowLog}
        setShowDeviceLog={setShowLogDevice}
        setShowFingerLog={setShowFingerLog}
        setChooseSapId={setChooseSapId}
        setOpenView={toggleDrawer(true)}

      />
      <LogSap
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        showLog={showLog}
        setShowLog={setShowLog}
      />
      <EmployeesDevice
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        showLog={showLogDevice}
        setShowLog={setShowLogDevice}
      />

      <LogFCountSap
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        showLog={showFingerLog}
        setShowLog={setShowFingerLog}
      />

      <FilterSap
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        structureId={structureId}
        devicePlaceId={devicePlaceId}
      />


      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onSapChoose={onSapChoose}
          chooseSapId={chooseSapId}
        />
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default EmployeesSap;
